var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-container",style:(`background-color:${_vm.backgroundColor}`)},[_c('div',{staticClass:"nav-menu",style:(`height:${_vm.height};lineHeight:${_vm.navHeight};padding-top:${_vm.navPadding};background-color:${_vm.backgroundColor}`)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }